import request from "@/utils/request";
import download from "@/utils/download";

// 工厂开票查询-实际
export const searchFactoryInvoices = (params: any) =>
  request({
    url: "/factory-invoices",
    method: "GET",
    params,
  });

// 工厂开票查询-原生
export const searchFactoryInvoicesNative = (params: any) =>
    request({
        url: "/factory-invoices/native",
        method: "GET",
        params,
    })

export const changeFactoryInvoices = (id: string, data: any) =>
  request({
    url: "/factory-invoices",
    method: "PUT",
    data,
  });
export const getFactoryInvoiceProducts = (id: string) =>
  request({
    url: `/factory-invoices/${id}/factory-invoice-products`,
    method: "GET",
  });
export const saveFactoryInvoiceProducts = (id: string, data: any) =>
  request({
    url: `/factory-invoices/${id}/factory-invoice-products`,
    method: "PUT",
    data,
  });
// 调整开票-额外费用结算
export const getMoneyList = (id: string, factoryName: string) =>
  request({
    url: `/factory-invoices/${id}/hq-packing-lists/money-list?factoryName=${factoryName}`,
    method: "GET",
  });

export const editMoneyList = (id: string, data: any) =>
    request({
        url: `/factory-invoices/${id}/hq-packing-lists/money-list`,
        method: "PUT",
        data
    });

export const updateCollectInvoiceState = (id: string, collectInvoiceState: string, date: string) => {
  request({
      url: `/factory-invoices/${id}/collect-invoice-state-and-date`,
      method: "PUT",
      data: { collectInvoiceState: collectInvoiceState , collectInvoiceDate: date},
  });
}

export const updateRemark = (id: string, remark: string) => {
    request({
        url: `/factory-invoices/${id}/remark`,
        method: "PUT",
        data: { remark: remark },
    })
}

export const downloadContract = (id: string) => {
    download({
        responseType: "blob",
        url: `/factory-invoices/${id}/contract`,
        method: "GET",
    })
}

export const queryFactoryInvoicePurchaseOrder = (id) =>
    request({
        url: `/factory-invoice/${id}/purchase-order`,
        method: "GET",
    });
